import type { ButtonProps } from '@launchpad-ui/components';
import { Button, Perceivable, Tooltip, TooltipTrigger } from '@launchpad-ui/components';
import cx from 'clsx';

import styles from './ActionBarButton.module.css';

export type ActionBarButtonProps = Omit<ButtonProps, 'className'> & {
  icon?: React.ReactNode;
  disabledTooltipText?: string;
  isDisabled?: boolean;
  children?: React.ReactNode;
};

export function ActionBarButton({ disabledTooltipText, icon, isDisabled, children, ...props }: ActionBarButtonProps) {
  const kind: ButtonProps['variant'] = props.variant || 'default';
  // disabled button with/without tooltip
  if (isDisabled) {
    return (
      <Perceivable>
        <TooltipTrigger>
          <Button variant="default" {...props} className={cx(styles.button, styles[kind])}>
            {icon}
            {children}
          </Button>
          {disabledTooltipText && <Tooltip placement="bottom start">{disabledTooltipText}</Tooltip>}
        </TooltipTrigger>
      </Perceivable>
    );
  }

  return (
    <Button variant="default" {...props} className={cx(styles.button, styles[kind])}>
      {icon}
      {children}
    </Button>
  );
}
